import React from "react";
import { Spinner } from "react-bootstrap";
import { useAppSelector } from "../../_App/Redux/hooks";
import {
  ListRapportClient,
  currentPageClient,
  totalPagesClient,
} from "../../_App/Redux/Slices/rapport/rapportSlice";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";

export default function RapportClientTable({
  t,
  index,
  setindex,
  loading,
  onClickClient,
}: any) {
  const listRapportClient = useAppSelector(ListRapportClient);
  const current_page = useAppSelector(currentPageClient);
  const totalpages = useAppSelector(totalPagesClient);

  if (loading) {
    return (
      <div className="text-center" style={{ marginTop: "100px" }}>
        <Spinner animation="grow" style={{ width: "80px", height: "80px" }} />
        <br />
        <strong>{t("Chargement...")}</strong>
      </div>
    );
  }

  return (
    <div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>{t("Code")}</th>
              <th>{t("Client")}</th>
              <th>{t("Mobile")}</th>
              <th>{t("Organisation")}</th>
              <th>{t("Nombre de tickets")}</th>
              <th>{t("Total des tickets")}</th>
              <th>{t("Points fidélité")}</th>
            </tr>
          </thead>
          <tbody>
            {listRapportClient &&
              listRapportClient.map((item: any, i: number) => (
                <tr key={item._id || i}>
                  <td
                    onClick={() => onClickClient && onClickClient(item._id)}
                    className="lien-bleu-souligne"
                    style={{ cursor: "pointer" }}
                  >
                    {item.barCode}
                  </td>
                  <td>
                    {item.nom} {item.prenom}
                  </td>
                  <td>{item.mobile}</td>
                  <td>{item.magasins}</td>
                  <td>{item.nombreCommandes}</td>
                  <td>{(item.totalCommandes || 0).toFixed(3)}</td>
                  <td>{item.points || 0}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
    </div>
  );
}
